import { buildApiTypes } from '@/modules/Vuex';

export const {
  actionTypes: API_GET_ACCOUNT_PRODUCTS,
} = buildApiTypes('account/API_GET_ACCOUNT_PRODUCTS');
